// Hero.tsx
'use client';

import React from "react";
import Image from "next/image";
import { Button } from "../ui/button";
import Link from "next/link";

const Hero: React.FC = () => {
  return (
    <section className="relative flex flex-col md:flex-row min-h-[70vh] lg:min-h-[100vh] overflow-hidden">
      {/* Left Half - Yellow Background with Content */}
      <div className="w-full md:w-1/2 bg-yellow-400 flex items-center justify-center p-8 md:p-12 lg:p-16 text-center md:text-left">
        <div className="max-w-xl mx-auto md:mx-0 text-gray-900">
          <p className="text-lg md:text-xl text-gray-700 mb-4 font-semibold">
           A Proud Partner of the Canadian  Industry
          </p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-medium leading-tight mb-6">
            Your Partner for High-Quality Industrial Goods & Equipment
          </h1>
          <p className="text-base sm:text-lg text-gray-600 mb-8 max-w-xl mx-auto md:mx-0">
            Join forces to transform your industrial vision into a stunning reality, ensuring every detail is executed with the utmost excellence and precision. Together, we can create spaces that inspire and endure.
          </p>
          <div className="flex flex-col sm:flex-row justify-center md:justify-start gap-4">
           <Link href="/contact"> 
            <Button
              variant="default"
              size="lg"
              className="bg-gray-900 hover:bg-gray-700 text-white font-semibold py-3 px-8 rounded-full shadow-lg transition-transform transform hover:scale-105"
              >
              Get Started Now
            </Button>
              </Link>
              <Link href="/about">  
            <Button
              variant="ghost" // Use ghost for a less prominent "Learn More"
              size="lg"
              className="text-gray-900 hover:bg-gray-100 font-semibold py-3 px-8 rounded-full transition-transform transform hover:scale-105"
              >
              Learn More
            </Button>
              </Link>
          </div>
        </div>
      </div>

      {/* Right Half - Image Background with Video Overlay */}
      <div
        className="relative w-full md:w-1/2 min-h-[50vh] md:min-h-full flex items-center justify-center"
      >
        <Image
          src="/parts.jpg"
          alt="Industrial Parts"
          fill
          style={{ objectFit: 'cover' }}
          className="z-0"
        />
      </div>
      </section>
  );
};

export default Hero